import $ from 'jquery';
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import 'datatables.net-bs5';
import 'datatables.net-fixedcolumns-bs5';
import 'datatables.net-fixedheader-bs5';
import 'datatables.net-select-bs5';
import 'datatables.net-buttons';
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import 'datatables.net-responsive';
import 'datatables.net-responsive-bs5';
import 'datatables.net-rowgroup-bs5';
import 'jquery-datatables-checkboxes';

// Make JSZip and pdfMake available globally after jQuery is loaded
if (window.$ && $.fn.dataTable) {
    window.JSZip = JSZip;
    $.fn.dataTable.ext.buttons.jszip = JSZip;
    $.fn.dataTable.ext.buttons.pdfMake = pdfMake;
} else {
    // Fallback: wait for jQuery to be available
    $(document).ready(function() {
        window.JSZip = JSZip;
        $.fn.dataTable.ext.buttons.jszip = JSZip;
        $.fn.dataTable.ext.buttons.pdfMake = pdfMake;
    });
}
